const LabelSection = ({ label, description }: { label: string; description: string }) => {
  return (
    <div className="flex flex-col space-y-1">
      <span className="text-[15px] font-semibold text-gray-700">{label}</span>
      <span className="text-[15px] text-gray-600">{description}</span>
    </div>
  );
};

export default LabelSection;
